import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
  as?: "p" | "span" | "div"
  size?: "xs" | "sm" | "base" | "lg" | "xl"
  weight?: "normal" | "medium" | "semibold" | "bold"
}

/**
 * Simple Text wrapper component for backward compatibility
 * Prefer using semantic HTML directly: <p>, <span>, etc.
 */
export const Text = React.forwardRef<HTMLElement, TextProps>(
  ({ className, as: Component = "p", size, weight, ...props }, ref) => {
    const sizeClasses = size ? {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
    }[size] : ""

    const weightClasses = weight ? {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    }[weight] : ""

    return (
      <Component
        ref={ref as any}
        className={cn(sizeClasses, weightClasses, className)}
        {...props}
      />
    )
  }
)
Text.displayName = "Text"
